import { render, staticRenderFns } from "./AccountSettingPassword.vue?vue&type=template&id=2e5b0995&scoped=true"
import script from "./AccountSettingPassword.vue?vue&type=script&lang=js"
export * from "./AccountSettingPassword.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingPassword.vue?vue&type=style&index=0&id=2e5b0995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b0995",
  null
  
)

export default component.exports